import React from "react";
import axiosInstance from "../../utility/axiosInstance";
import {auth} from "../../utility/api";
import {NavLink, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useErrorBoundary} from "react-error-boundary";

const UnauthorizedIndex = ({error, resetErrorBoundary}) => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const {resetBoundary} = useErrorBoundary();
    return (
        <div className="m-auto text-center min-h-screen flex flex-col items-center justify-center bg-gray-100"
            style={
                {
                    fontFamily: "Arial, sans-serif",
                    color: "#333"
                }
        }>
            <h1 style={
                {
                    fontSize: "2.5rem",
                    marginBottom: "1rem",
                    color: "#ff4d4f"
                }
            }>
                {
                t("UnauthorizedAccess.title")
            } </h1>
            <p style={
                {
                    fontSize: "1.25rem",
                    marginBottom: "2rem"
                }
            }>
                {
                t("UnauthorizedAccess.message")
            } </p>
            <div style={
                {
                    display: "flex",
                    gap: "1rem"
                }
            }>
                <NavLink to={"/"}
                    onClick={
                        () => {
                            resetBoundary()
                            window.location.reload()
                        }
                }>

                    <button style={
                            {
                                padding: "0.75rem 1.5rem",
                                fontSize: "1rem",
                                color: "#fff",
                                backgroundColor: "#007bff",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                                transition: "background-color 0.3s ease"
                            }
                        }
                        onMouseEnter={
                            (e) => (e.target.style.backgroundColor = "#0056b3")
                        }
                        onMouseLeave={
                            (e) => (e.target.style.backgroundColor = "#007bff")
                    }>
                        {
                        t("sidebar.menu.home")
                    } </button>
                </NavLink>
                <button onClick={
                        async () => {
                            try {
                                const response = await axiosInstance.post(auth.logout);
                                console.log(response);

                                if (response.status === 200) {
                                    localStorage.removeItem("token");
                                    window.location.reload();
                                    // navigate("/");
                                }
                            } catch (error) {
                                console.error("Error during logout:", error);
                            }
                        }
                    }
                    style={
                        {
                            padding: "0.75rem 1.5rem",
                            fontSize: "1rem",
                            color: "#fff",
                            backgroundColor: "#dc3545",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            transition: "background-color 0.3s ease"
                        }
                    }
                    onMouseEnter={
                        (e) => (e.target.style.backgroundColor = "#a71d2a")
                    }
                    onMouseLeave={
                        (e) => (e.target.style.backgroundColor = "#dc3545")
                }>
                    {
                    t("navbar.logout")
                } </button>
            </div>
        </div>
    );
};

export default UnauthorizedIndex;
